<!-- =========================================================================================
  File Name: Users.vue
  Description: User list
  ----------------------------------------------------------------------------------------
  Item Name: C4 - User list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>
  <div class="h-64">
    <!--    <div class="vx-col w-full mb-base">-->
    <vx-card ref="parametersCard" class="mb-2">
      <div class="flex justify-between inline-block align-middle">
        <div class="mr-2" style="min-width: 220px;">
          <ejs-datepicker ref="period" v-model="date" floatLabelType="Auto" placeholder="Existencias al día"/>
        </div>
        <div class="w-full">
          <ejs-dropdownlist
            floatLabelType="Auto"
            placeholder="Seleccione bodega (en blanco para calcular existencia en todas)"
            ref="warehouse"
            highlight=true
            v-model="warehouseId"
            :dataSource="warehouses"
            :fields="{text: 'name', value: 'id'}"
            :query='warehouseQuery'
            allowFiltering=true
            :filtering='warehouseFiltering'
            showClearButton=true
          />
        </div>
        <div>
          <vs-button radius color="success" type="filled" icon-pack="feather" icon="icon-search" class="ml-4 mt-2" @click="getReport"/>
        </div>
      </div>
    </vx-card>
    <vx-card ref="reportCard" v-show="gridReady">
      <ejs-grid
        ref="grid"
        :dataSource="data"
        locale='es-GT'
        :toolbar='toolbarOptions'
        :allowPaging="true"
        :pageSettings='pageSettings'
        :allowSorting='true'
        :sortSettings='sortOptions'
        :allowExcelExport='true'
        :toolbarClick='toolbarClick'
      >
        <e-columns>
          <e-column field="id" :visible=false headerText="ID" :isPrimaryKey="true"/>
          <e-column field="categoryName" headerText="Categoría" width="200"/>
          <e-column field="code" headerText="Código de producto" width="200"/>
          <e-column field="name" headerText="Descripción"/>
          <e-column field="stock" type="number" headerText="Existencia" textAlign='Right' format="N2" width="120"/>
          <e-column field="value" type="number" headerText="Valor" textAlign='Right' format="C2" width="120"/>
          <e-column field="cost" type="number" headerText="Costo Unitario" textAlign='Right' format="N8" width="140"/>
        </e-columns>
      </ejs-grid>
    </vx-card>
    <!--      <vx-card v-show="gridReady">-->
    <!--    <ejs-spreadsheet-->
    <!--      ref="spreadsheet"-->
    <!--      :showSheetTabs="false"-->
    <!--      :allowDelete="false"-->
    <!--      :allowInsert="false"-->
    <!--      :allowEditing="false"-->
    <!--      :allowSave="true"-->
    <!--      :saveUrl="saveUrl"-->
    <!--      :showRibbon="true"-->
    <!--      style="height: 600px;"-->
    <!--    >-->
    <!--      <e-columns>-->
    <!--        <e-column :width="200"/>-->
    <!--        <e-column :width="160"/>-->
    <!--        <e-column :width="360"/>-->
    <!--        <e-column :width="80"/>-->
    <!--        <e-column :width="120"/>-->
    <!--        <e-column :width="120"/>-->
    <!--      </e-columns>-->
    <!--    </ejs-spreadsheet>-->
  </div>
</template>

<script>
var deltaPOS_config = require('@/deltaPOS.config')

import Vue from 'vue';
import * as lang from 'vuejs-datepicker/src/locale';
import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
import {Query} from "@syncfusion/ej2-data";
import {GridPlugin, Toolbar, Search, Page, Sort, ExcelExport, Aggregate} from '@syncfusion/ej2-vue-grids';
import {DatePickerPlugin} from '@syncfusion/ej2-vue-calendars';
import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
// import {SpreadsheetPlugin} from '@syncfusion/ej2-vue-spreadsheet';
import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
import numbers from 'cldr-data/main/es-GT/numbers.json';
import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
import CellRendererLink from '@/views/infra/cell-renderer/CRLinkS';

Vue.use(DatePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(GridPlugin);
// Vue.use(SpreadsheetPlugin);

loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
setCulture('es-GT');
L10n.load({
  'es-GT': {
    'datepicker': {
      placeholder: 'Seleccione fecha',
      today: 'Hoy'
    },
    'grid': {
      'EmptyRecord': 'No se encontraron productos',
      'Search': 'Buscar',
      'Excelexport': 'Exportar'
    },
    'pager': {
      'currentPageInfo': '{0} de {1} páginas',
      'firstPageTooltip': 'Ir a primera página',
      'lastPageTooltip': 'Ir a última página',
      'nextPageTooltip': 'Ir a página siguiente',
      'previousPageTooltip': 'Ir a página anterior'
    }
  }
});

export default {
  data() {
    return {
      loaded: false,
      gridReady: false,
      language: lang,
      date: null,
      warehouses: [],
      warehouseId: null,
      warehouseQuery: new Query().select(['name', 'id']).take(10),
      data: [],
      editID: null,
      addNewDataSidebar: false,
      dateFormatOptions: {type: 'dateTime', format: 'dd/MM/yyyy hh:mm a'},
      pageSettings: {pageSize: 15},
      toolbarOptions: ['Search', 'ExcelExport'],
      sortOptions: {columns: [{field: 'categoryName', direction: 'Ascending'}, {field: 'name', direction: 'Ascending'}]},
      saveUrl: 'https://ej2services.syncfusion.com/production/web-services/api/spreadsheet/save',
      cardTitle: 'Listado de ventas',
      cTemplate: function () {
        return {template: CellRendererLink, urlBase: '/sale/transaction/'};
      }
    }
  },
  components: {
    // AddNewDataSidebar,
    CellRendererLink
  },
  provide: {
    grid: [Toolbar, Search, Page, Sort, ExcelExport, Aggregate]
  },
  methods: {
    warehouseFiltering: function (e) {
      var searchData = JSON.parse(JSON.stringify(this.warehouses));
      if (e.text == '') {
        e.updateData(searchData);
      } else {
        // var query = new Query().select(['name', 'id']);
        var query = new Query().select(['searchName', 'id']);
        query = (e.text !== '') ? query.where('searchName', 'contains', e.text, true, true) : query;
        e.updateData(searchData, query);
      }
    },
    numericFormat(value, decimals) {
      var ret = value;
      if (typeof value !== 'undefined') {
        ret = value.toFixed(decimals).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      }
      return ret;
    },
    discountFormatter(field, data) {
      return (data[field] == 0 ? '' : data[field].toFixed(2));
    },
    dateFormat(value) {
      var d = new Date(value);
      // return `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
      return d.toLocaleString('es-GT', {dateStyle: 'short', timeStyle: 'medium'})
    },
    dateISOFormat(value) {
      const d = new Date(value.getTime() - (6 * 60 * 60 * 1000));
      return d.toISOString();
    },
    formatDate: function (field, data) {
      var d = new Date(data[field].replace('Z', ''));
      return d.toLocaleString('es-GT', {dateStyle: 'short'});
      // return `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
    },
    toolbarClick: function (args) {
      if (args.item.id.includes('excelexport')) { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
        let excelExportProperties = {
          fileName: `Existencias al ${this.date.toLocaleString('es-GT', {dateStyle: 'long'})}.xlsx`
        };
        this.$refs.grid.excelExport(excelExportProperties);
      }
    },
    getReport() {
      this.$vs.loading({
        text: 'Cargando consulta',
        type: 'point'
      });
      var self = this;
      var data = {
        endDate: this.dateISOFormat(this.date),
        warehouseId: this.warehouseId,
        userId: this.$store.state.AppActiveUser.userId,
        token: this.$store.state.AppActiveUser.token
      };
      this.$http.post(deltaPOS_config.default.apiURL + '/reports/stock/stock_date', data).then(response => {
        // self.sheetObj.clear();
        if (response.data.success) {
          if (response.data.data) {
            /*
                        let rows = [];
                        rows.push({index: 1, cells: [{value: 'Bakery Depot', style: {fontWeight: 'bold', fontSize: '14pt'}}]});
                        rows.push({cells: [{value: `Existencias al ${self.date.toLocaleString('es-GT', {dateStyle: 'short'})}`, style: {fontWeight: 'bold'}}]});
                        rows.push({cells: [{value: 'Bodega:'}, {value: 'La bodega aquí'}]});
                        rows.push(null);
                        rows.push({
                          cells: [
                            {value: 'Categoría', style: {fontWeight: 'bold', borderBottom: '1px solid #000000'}},
                            {value: 'Código', style: {fontWeight: 'bold', borderBottom: '1px solid #000000'}},
                            {value: 'Nombre', style: {fontWeight: 'bold', borderBottom: '1px solid #000000'}},
                            {value: 'Existencia', style: {textAlign: 'right', fontWeight: 'bold', borderBottom: '1px solid #000000'}},
                            {value: 'Costo unitario', style: {textAlign: 'right', fontWeight: 'bold', borderBottom: '1px solid #000000'}},
                            {value: 'Valor', style: {textAlign: 'right', fontWeight: 'bold', borderBottom: '1px solid #000000'}}
                          ]
                        })
                        const firstLine = 6;
                        let line = firstLine - 1;
                        for (const row of response.data.data) {
                          line++;
                          rows.push({
                            cells: [
                              {value: row.categoryName},
                              {value: row.code},
                              {value: row.name},
                              {value: row.stock},
                              {value: 0, format: '0.000000'},
                              {value: 0, formula: `=D${line}*E${line}`, format: '_(#,##0.00_);_((#,##0.00);_("-"??_);_(@_)'}
                            ]
                          });
                        }
                        rows.push({
                          cells: [
                            {value: '', style: {borderTop: '1px solid #000000'}},
                            {value: '', style: {borderTop: '1px solid #000000'}},
                            {value: '', style: {borderTop: '1px solid #000000'}},
                            {value: '', style: {borderTop: '1px solid #000000'}},
                            {value: 'Total:', style: {fontWeight: 'bold', borderTop: '1px solid #000000'}},
                            {value: 0, formula: `=SUM(F${firstLine}:F${line}`, format: '_(#,##0.00_);_((#,##0.00);_("-"??_);_(@_)', style: {borderTop: '1px solid #000000'}}
                          ]
                        });
                        self.$refs.spreadsheet.ej2Instances.properties.sheets[0].rows = rows;
                        self.$refs.spreadsheet.ej2Instances.properties.sheets[0].columns[0].width = 200;
                        self.$refs.spreadsheet.ej2Instances.properties.sheets[0].columns[1].width = 160;
                        self.$refs.spreadsheet.ej2Instances.properties.sheets[0].columns[2].width = 360;
                        self.$refs.spreadsheet.ej2Instances.properties.sheets[0].columns[3].width = 80;
                        self.$refs.spreadsheet.ej2Instances.properties.sheets[0].columns[4].width = 120;
                        self.$refs.spreadsheet.ej2Instances.properties.sheets[0].columns[5].width = 120;
                        self.$refs.spreadsheet.ej2Instances.refresh();
            */
            self.data = response.data.data
          } else {
            self.data = [];
          }
          self.gridReady = true;
          self.$vs.loading.close();
        } else {
          self.$vs.loading.close();
          self.$vs.notify({
            title: 'Error al cargar reporte de existencias',
            text: response.data.message,
            color: 'danger'
          });
        }
        self.loaded = true;
      }).catch(error => {
        self.loaded = true;
        this.$vs.loading.close();
        var errorMessage = '';
        if (error.response) {
          errorMessage = error.response.data.ErrorMessage
        } else {
          errorMessage = 'Error de conectividad'
        }
        self.$vs.notify({
          title: 'Error al cargar reporte de existencias',
          text: errorMessage,
          color: 'danger'
        });
      });
    }
  },
  mounted() {
    this.date = new Date();
    this.date.setHours(0);
    this.date.setMinutes(0);
    this.date.setSeconds(0);
    var self = this;
    this.$http
      .post(deltaPOS_config.default.apiURL + '/stock/warehouses/list', this.$store.state.AppActiveUser)
      .then(response => {
        if (response.data.success) {
          self.warehouses = response.data.data;
          self.$vs.loading.close();
        } else {
          self.$vs.loading.close();
          this.$vs.notify({
            title: 'Error al cargar bodegas',
            text: response.data.message,
            color: 'danger'
          });
        }
      });
  }
}
</script>

<style lang="scss">
@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-lists/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import "../../../../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-spreadsheet/styles/material.css";
</style>
